// extracted by mini-css-extract-plugin
module.exports = {"SecondaryHeader":"SecondaryHeader_SecondaryHeader__3CwSe","divider":"SecondaryHeader_divider__3-iT7"};